import React from 'react'
import classNames from 'classnames'

import { Container } from '@scentregroup/ui'
import style from './index.scss'

export const MarketplaceContainer: React.FC<{
  className?: string
}> = ({ className, children }) => (
  <Container type="large" className={classNames(className, style.container)}>
    {children}
  </Container>
)
